<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách file import</h1>
      <div class="btn-group float-right">
        <!-- <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Import Files"
          @click="$router.push({name: 'FileImport'})">
          <i class="bx bx-download"></i><span>&nbsp;</span>Import file
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="[
                {
                  id: 'NO_APPROVE',
                  text: 'Chưa duyệt',
                },
                {
                  id: 'APPROVE',
                  text: 'Đã duyệt',
                },
                {
                  id: 'REJECT',
                  text: 'Từ chối',
                },
              ]"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    @click="$router.push('/file/detail/' + item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { FileService } from '@/services/file.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    name: 'gpdkkd-sale',
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        Config,
        filterTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'name', label: 'Tên file' },
          { key: 'totalRecord', label: 'Tổng số bản ghi', class: 'text-center' },
          { key: 'type', label: 'Loại', class: 'text-center' },
          {
            key: 'createTime',
            label: 'Thời gian tạo',
            formatter: value => this.$options.filters.formatDate(value, 'HH:mm DD/MM/YYYY'),
          },
          { key: 'creator.email', label: 'Người tạo' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
        ],
        lists: [],
        loading: false,
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = cloneDeep(this.search)
          const response = await FileService.fetchAll(params)
          if (response.code === 1000) {
            this.lists = response.data.fileImportRes
            const processList = this.lists.filter(s => s.status === 'PROCESSING')
            console.log(processList)
            this.pagination.total = response.data.count
          } else {
            this.lists = []
            this.pagination.total = 0
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>
